import { DocumentConfigKey } from 'helpers/constanst'
import { put, select, takeEvery } from 'redux-saga/effects'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { getConfigListAPI } from './api'

export const getUser = (state: any) => state.userReducer.currentUser

function* getConfigList(): any {
  try {
    const currentUser = yield select(getUser)
    yield put(
      getConfigListAPI(
        {
          config: `${DocumentConfigKey.TAX},${DocumentConfigKey.QUOTATION},${DocumentConfigKey.DELIVERY},${DocumentConfigKey.COMMON},${DocumentConfigKey.BARCODE}`,
        },
        currentUser.accessToken,
        currentUser?.activeMerchant?.uuid || '',
      ),
    )
  } catch (e) {
    console.log(e)
  }
}

function* posSaga() {
  yield takeEvery(getType(actions.setConfigAction.success), getConfigList)
}

export default posSaga
